export default {
  errors: (state) => state.errors,
};
